export const databaseSourceConstants = {
  CREATE_DATABASESOURCE: 'CREATE_DATABASESOURCE',
  RETRIEVE_DATABASESOURCE: 'RETRIEVE_DATABASESOURCE',
  UPDATE_DATABASESOURCE: 'UPDATE_DATABASESOURCE',
  DELETE_DATABASESOURCE: 'DELETE_DATABASESOURCE',
  DELETE_ALL_DATABASESOURCE: 'DELETE_ALL_DATABASESOURCE',
}
